var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutorials(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lighten_bulb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 7.72656H1.97157V8.31235H0V7.72656Z",
    fill: "#393B4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.32786 4.17203L1.73828 3.08984L3.32786 4.17203Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.55078 3.32812L1.92453 2.85598L3.51359 3.93892L3.13984 4.41107L1.55078 3.32812Z",
    fill: "#393B4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.77997 1.83303L6.15625 0.0976562L6.77997 1.83303Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.85938 0.191406L6.45855 0.00628502L7.08157 1.74232L6.48239 1.92745L5.85938 0.191406Z",
    fill: "#393B4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.2188 1.83303L11.8425 0.0976562L11.2188 1.83303Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.9102 1.73438L11.5332 -0.0016644L12.1324 0.183457L11.5093 1.9195L10.9102 1.73438Z",
    fill: "#393B4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.6719 4.17593L16.2614 3.09375L14.6719 4.17593Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M14.4785 3.92969L16.0676 2.84674L16.4413 3.31889L14.8523 4.40183L14.4785 3.92969Z",
    fill: "#393B4A"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.0312 7.72656H18.0029V8.31235H16.0312V7.72656Z",
    fill: "#393B4A"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.9501 10.1087L13.404 11.1954H13.4312C13.4089 11.2414 13.3867 11.2873 13.3644 11.3333C12.9265 12.238 12.4823 13.1555 12.1223 14.0451C11.6943 15.1027 11.3539 16.1905 11.255 17.2905H8.98965H6.72442C6.62601 16.191 6.2872 15.1035 5.86057 14.0459C5.49883 13.1491 5.052 12.225 4.61141 11.3137C4.59234 11.2743 4.57328 11.2348 4.55424 11.1954H4.58146L4.03542 10.1087C3.71518 9.47139 3.53711 8.76367 3.53711 8.01729C3.53711 5.30497 5.92551 3.01172 8.99274 3.01172C12.06 3.01172 14.4484 5.30497 14.4484 8.01729C14.4484 8.76367 14.2703 9.47139 13.9501 10.1087Z",
    stroke: "#393B4A",
    strokeWidth: 1.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M3.23345 9.98825H2.88896L14.5289 9.8844C14.7634 9.28826 14.8819 8.66218 14.8819 8.0172C14.8819 8.0172 14.8819 8.0172 14.8819 8.0172C14.8819 5.00508 12.2397 2.55455 8.99199 2.55455C8.99199 2.55455 8.99199 2.55455 8.99199 2.55455C5.74428 2.55455 3.10205 5.00509 3.10204 8.0172C3.10204 8.0172 3.10204 8.0172 3.10204 8.0172C3.10204 8.6622 3.22061 9.28831 3.45515 9.88447L3.23345 9.98825Z",
    fill: "#393B4A",
    stroke: "#393B4A",
    strokeWidth: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M5.72852 18.582H12.2441V20.0004H5.72852V18.582Z",
    fill: "#393B4A"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.4ee7a06fde7bbc8999fda1d2e741b294.svg";
export { ForwardRef as ReactComponent };